<template>
    <div
        id="internal-navigation"
        aria-hidden="true"
        class="bg-white"
        :style="`box-shadow: 0 0.5rem 0.5rem -0.25rem rgba(0, 0, 0, 0.1);`"
    >
        <nav class="container overflow-auto p-2 pb-1">
            <ul class="tabs flex border-b border-white">
                <li v-for="(item, i) in items" :key="`internal-nav-item-${i}`">
                    <button
                        tabindex="-1"
                        :data-target="item.url"
                        class="tab-link relative px-4 py-2 whitespace-nowrap"
                        :class="{ 'tab-link--active': activeHash === item.url }"
                        @click="$emit('update-active-hash', item.url)"
                    >
                        {{ item.name }}
                    </button>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
// aria-hidden is applied on this component because screenreaders
// can navigate between headings anyway with a keyboard shortcut

export default {
    name: 'InternalNavBar',
    props: {
        activeHash: {
            type: String,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped>
.tab-link::after {
    content: '';
    @apply block absolute bottom-[-5px] left-0 w-full h-[5px] bg-blue-400 z-1 rounded-full opacity-0 transition-opacity;
}

.tab-link.tab-link--active {
    @apply font-bold;
}

@media (hover: hover) {
    .tab-link:hover::after {
        @apply opacity-100;
    }
}
.tab-link.tab-link--active::after {
    @apply opacity-100;
}
</style>
